module.exports = __webpack_public_path__ + "img/stock4.f4bc86ea.png";